import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/views/HostingPage.tsx");
